// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"14":"route.subcategories","84":"route.categories","103":"route.settings","525":"route.location","945":"route.leadership"}[chunkId] + "." + {"14":"23dbe856","84":"24eb764b","103":"caaf7c05","525":"44d79819","945":"b67e1bc2"}[chunkId] + ".chunk.js";
};